import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { Amplify } from 'aws-amplify';
import { awsconfig } from 'aws-exports';
import App from './App';
import * as serviceWorker from './serviceWorker';

Amplify.configure(awsconfig);
// eslint-disable-next-line react/no-render-return-value
const renderApp = () => ReactDOM.render(<App />, document.getElementById('root'));

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('./App', renderApp);
}

renderApp();

serviceWorker.unregister();
